// Opening Balances — opening_balances.* (Finance)
//
// The keys were approved on 21 Sep 2026, so the amer-laravel migration that
// registers them —
// `2026_09_21_000002_add_finance_close_and_control_and_department_restore_permissions.php`
// — has moved up out of `database/migrations/pending-central-approval/` and runs
// with the rest of the tenant migrations. The ids below are the central key
// service's **approval numbers**, which that migration writes as each permission
// row's own `permissions.id` — the two have to stay equal.
//
// They are not free to choose: an id here that does not equal its backend row id
// fails silently. `HAS_PERMISSION` simply returns false, so the page, the sidebar
// leaf and every gated button never appear, with nothing logged anywhere. Read an
// issued id off the registry; never derive the next one from the last.

/** opening_balances.index — the register, and opening a row in it. */
export const OPENING_BALANCES_INDEX = 1637;

/**
 * opening_balances.show — collapsed into `index` by the August 2026 audit.
 *
 * Aliased rather than pointed at a key that does not exist: a constant naming a
 * missing key makes `HAS_PERMISSION` false forever and the record page vanishes
 * for everyone. Whoever may list the register may open a row in it.
 */
export const OPENING_BALANCES_SHOW = OPENING_BALANCES_INDEX;

/**
 * opening_balances.import — recording a draft, correcting it, replaying the
 * check, and posting the journal.
 *
 * One key for all four on purpose: they are one act carried out in stages, and a
 * role that may bring the office's balance sheet in may do all of them. The route
 * file says so explicitly ("three keys and six routes").
 */
export const OPENING_BALANCES_IMPORT = 1638;

/**
 * opening_balances.reverse — posting the mirrored contra and letting the import
 * go. Separate because it takes the whole balance sheet back out again.
 */
export const OPENING_BALANCES_REVERSE = 1639;
